import React from 'react';
import { connect } from 'react-redux';
import ExportBlob from '../../../../common/export-blob';

class ExportCommon extends React.Component {
  handleExport = () => {
    const { exportFunction } = this.props;
    exportFunction();
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
